/*
 *@providesModule RenderUtils
 *
 */

import _ from 'lodash';

export default class RenderUtils {
  /*This class exists for performance optimization to reduce wasted renders */

  static shouldAllowStateChangeRerender(
    currentState: Object,
    futureState: Object,
    renderlessVars: Array<String> | null = null,
    currentProps: Object | null = null,
    futureProps: Object | null = null
  ): boolean {
    if (!_.isEqual(currentProps, futureProps)) {
      return true;
    }

    const allKeys = _.union(Object.keys(currentState), Object.keys(futureState));

    return (
      _.find(allKeys, (key: string): boolean => {
        return (
          !renderlessVars?.includes(key as string) &&
          !_.isEqual(
            currentState[key as keyof typeof currentState],
            futureState[key as keyof typeof futureState]
          )
        );
      }) != null
    );
  }

  static shouldAllowRerenderFromPropsChange(
    currentProps: Object,
    futureProps: Object,
    propsToCompare: Array<String>
  ): boolean {
    const hasDifference = _.find(propsToCompare, (propKey: string): boolean => {
      return !_.isEqual(currentProps[propKey], futureProps[propKey]);
    });
    return hasDifference != null;
  }
}
